import styled, {createGlobalStyle} from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';
import {globalDatePickerStyles} from '@shared/ui/DatePicker';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  button, input, textarea {
    font-family: inherit;
  }

  ${globalDatePickerStyles}
`;

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    pointer-events: none;
    background: #f0f4f7;
`;
